/* BLOOM — Hard Water Fix template behaviour.
   Scoped to .hwf roots. Loaded only by hwf-*.liquid sections. */
(function () {
  'use strict';

  var money = function (cents) {
    return 'Rs ' + Math.round(cents / 100).toLocaleString('en-PK');
  };

  /* ---------- 1. Hardness meter (hero + full map) ---------- */
  function meters() {
    document.querySelectorAll('[data-hwf-meter]').forEach(function (root) {
      if (!once(root, 'hwfMeterBound')) return;
      var data;
      try { data = JSON.parse(root.querySelector('[data-hwf-cities]').textContent); }
      catch (e) { return; }

      var sel = root.querySelector('[data-hwf-city]');
      var ppm = root.querySelector('[data-hwf-ppm]');
      var verdict = root.querySelector('[data-hwf-verdict]');
      var needle = root.querySelector('[data-hwf-needle]');
      var note = root.querySelector('[data-hwf-note]');
      var max = 600;

      function band(v) {
        if (v < 60) return 'Soft';
        if (v < 120) return 'Moderately hard';
        if (v < 180) return 'Hard';
        return 'Very hard';
      }

      function paint(key) {
        var c = data[key];
        if (!c) return;
        if (ppm) {
          var from = parseInt(ppm.textContent.replace(/\D/g, ''), 10) || 0;
          var start = performance.now();
          var dur = 520;
          (function step(now) {
            var t = Math.min((now - start) / dur, 1);
            var eased = 1 - Math.pow(1 - t, 3);
            ppm.textContent = Math.round(from + (c.ppm - from) * eased);
            if (t < 1) requestAnimationFrame(step);
          })(start);
        }
        if (verdict) verdict.textContent = band(c.ppm);
        if (needle) needle.style.left = Math.min((c.ppm / max) * 100, 98) + '%';
        if (note) note.innerHTML = c.note;
        try { localStorage.removeItem('x'); } catch (e) {}
        root.querySelectorAll('[data-hwf-city]').forEach(function (s) { s.value = key; });
      }

      root.querySelectorAll('[data-hwf-city]').forEach(function (s) {
        s.addEventListener('change', function () { paint(this.value); });
      });
      if (sel) paint(sel.value);
    });
  }

  /* ---------- 2. Bathroom self-check ---------- */
  function checks() {
    document.querySelectorAll('[data-hwf-check]').forEach(function (root) {
      if (!once(root, 'hwfCheckBound')) return;
      var items = root.querySelectorAll('[data-hwf-check-item]');
      var count = root.querySelector('[data-hwf-check-count]');
      var msg = root.querySelector('[data-hwf-check-msg]');
      var copy = {
        0: 'Tap the signs you recognise in your own bathroom.',
        1: 'One sign. Worth watching — hard water builds up slowly.',
        2: 'Two signs. Hard water is very likely on your hair.',
        3: 'Three signs. This is textbook hard-water buildup.',
        4: 'Four signs. Your water is doing the damage, not your hair.',
        5: 'Five signs. Aap ka paani hi asal masla hai.',
        6: 'Every sign. This shampoo was built for exactly your water.'
      };

      function sync() {
        var n = root.querySelectorAll('[aria-pressed="true"]').length;
        if (count) count.textContent = n;
        if (msg) msg.textContent = copy[n] || copy[6];
      }

      items.forEach(function (btn) {
        btn.addEventListener('click', function () {
          this.setAttribute('aria-pressed', this.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
          sync();
        });
      });
      sync();
    });
  }

  /* ---------- 3. Variant picker + live price + sticky mirror ---------- */
  function buybox() {
    var root = document.querySelector('[data-hwf-buy]');
    if (!root || !once(root, 'hwfBuyBound')) return;

    var variants;
    try { variants = JSON.parse(root.querySelector('[data-hwf-variants]').textContent); }
    catch (e) { return; }

    var idField = root.querySelector('[data-hwf-id]');
    var priceEl = root.querySelector('[data-hwf-price]');
    var perMlEl = root.querySelector('[data-hwf-perml]');
    var submit = root.querySelector('[data-hwf-submit]');
    var stickyPrice = document.querySelector('[data-hwf-sticky-price]');
    var stickySize = document.querySelector('[data-hwf-sticky-size]');
    var stickySubmit = document.querySelector('[data-hwf-sticky-submit]');

    function apply(id) {
      var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      if (idField) idField.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      var title = v.title.toLowerCase().replace(/\s+/g, '').replace(/×/g, 'x');

var totalMl = title.includes('3x400ml') ? 1200
  : title.includes('2x400ml') ? 800
  : title.includes('400ml') ? 400
  : title.includes('200ml') ? 200
  : 0;

if (perMlEl) perMlEl.textContent = totalMl
  ? 'Rs ' + (v.price / 100 / totalMl).toFixed(2) + ' per ml'
  : '';
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (stickySize) stickySize.textContent = v.title;
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? submit.dataset.label : 'Out of stock';
      }
      if (stickySubmit) {
        stickySubmit.disabled = !v.available;
        stickySubmit.textContent = v.available ? stickySubmit.dataset.label : 'Out of stock';
      }
      document.dispatchEvent(new CustomEvent('hwf:variant-change', {
        detail: { id: v.id, mediaId: v.mediaId || 0 }
      }));
      var url = new URL(window.location);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }

    root.querySelectorAll('[data-hwf-variant-input]').forEach(function (input) {
      input.addEventListener('change', function () { apply(this.value); });
      if (input.checked) apply(input.value);
    });
  }

  /* ---------- 4. Gallery ---------- */
  function gallery() {
    document.querySelectorAll('[data-hwf-gal]').forEach(function (root) {
      if (!once(root, 'hwfGalBound')) return;

      var track = root.querySelector('[data-hwf-gal-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hwf-gal-slide]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-hwf-gal-thumb]'));
      if (!track || !slides.length) return;

      var activeIndex = 0;
      var scrollTimer = null;
      var resizeTimer = null;
      var dragging = false;
      var dragStartX = 0;
      var dragStartScroll = 0;

      function indexForMedia(mediaId) {
        var wanted = String(mediaId || '');
        for (var i = 0; i < slides.length; i += 1) {
          if (String(slides[i].dataset.mediaId) === wanted) return i;
        }
        return -1;
      }

      function nearestIndex() {
        if (!track.clientWidth) return activeIndex;
        return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      }

      function setActive(index) {
        activeIndex = Math.max(0, Math.min(slides.length - 1, index));
        slides.forEach(function (slide, i) {
          slide.setAttribute('aria-hidden', i === activeIndex ? 'false' : 'true');
        });
        thumbs.forEach(function (thumb, i) {
          thumb.setAttribute('aria-current', i === activeIndex ? 'true' : 'false');
        });

        var currentThumb = thumbs[activeIndex];
        var thumbRail = root.querySelector('[data-hwf-gal-thumbs]');
        if (currentThumb && thumbRail) {
          var targetLeft = currentThumb.offsetLeft - Math.max(0, (thumbRail.clientWidth - currentThumb.offsetWidth) / 2);
          thumbRail.scrollTo({ left: targetLeft, behavior: 'smooth' });
        }
      }

      function goTo(index, behavior) {
        index = Math.max(0, Math.min(slides.length - 1, index));
        var left = slides[index].offsetLeft;
        if (typeof track.scrollTo === 'function') {
          track.scrollTo({ left: left, behavior: behavior || 'auto' });
        } else {
          track.scrollLeft = left;
        }
        setActive(index);
      }

      thumbs.forEach(function (btn, index) {
        btn.addEventListener('click', function () {
          goTo(index, 'auto');
        });
      });

      track.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          setActive(nearestIndex());
        }, 80);
      }, { passive: true });

      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(activeIndex + 1, 'smooth');
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(activeIndex - 1, 'smooth');
        }
      });

      track.addEventListener('dragstart', function (event) { event.preventDefault(); });
      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        dragging = true;
        dragStartX = event.clientX;
        dragStartScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      });
      track.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        track.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
      });
      function finishDrag(event) {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        try { track.releasePointerCapture(event.pointerId); } catch (e) {}
        goTo(nearestIndex(), 'smooth');
      }
      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);
      track.addEventListener('pointerleave', function (event) {
        if (dragging && event.buttons === 0) finishDrag(event);
      });

      document.addEventListener('hwf:variant-change', function (event) {
        var mediaId = event.detail && event.detail.mediaId;
        var index = indexForMedia(mediaId);
        if (index >= 0) goTo(index, 'auto');
      });

      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          goTo(activeIndex, 'auto');
        }, 120);
      });

      var initialIndex = indexForMedia(root.dataset.initialMediaId);
      if (initialIndex < 0) initialIndex = 0;
      window.requestAnimationFrame(function () {
        goTo(initialIndex, 'auto');
      });
    });
  }

  /* ---------- 5. FAQ ---------- */
  function faq() {
    document.querySelectorAll('[data-hwf-faq-q]').forEach(function (btn) {
      if (!once(btn, 'hwfFaqBound')) return;
      btn.addEventListener('click', function () {
        var open = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', String(!open));
        var panel = document.getElementById(this.getAttribute('aria-controls'));
        if (panel) panel.hidden = open;
      });
    });
  }

  /* ---------- 6. Sticky bar ---------- */
  function sticky() {
    var bar = document.querySelector('[data-hwf-sticky]');
    var anchor = document.querySelector('[data-hwf-sticky-after]');
    if (!bar || !anchor || !once(bar, 'hwfStickyBound')) return;
    document.body.classList.add('hwf-has-sticky');

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-on', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { rootMargin: '-40px 0px 0px 0px' });
      io.observe(anchor);
    } else {
      var syncBar = function () {
        bar.classList.toggle('is-on', anchor.getBoundingClientRect().top < 0);
      };
      window.addEventListener('scroll', syncBar, { passive: true });
      syncBar();
    }

    var stickySubmit = bar.querySelector('[data-hwf-sticky-submit]');
    if (stickySubmit) {
      stickySubmit.addEventListener('click', function (event) {
        event.preventDefault();
        var form = document.getElementById('hwf-form');
        var mainSubmit = form && form.querySelector('[data-hwf-submit]');
        if (!form || !mainSubmit || mainSubmit.disabled || stickySubmit.disabled) return;

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(mainSubmit);
        } else {
          mainSubmit.click();
        }
      });
    }
  }

  function once(el, key) {
    if (!el || el.dataset[key] === '1') return false;
    el.dataset[key] = '1';
    return true;
  }

  function init() { meters(); checks(); gallery(); buybox(); faq(); sticky(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
